module.exports = __webpack_public_path__ + "static/media/hongkong.d775d2ce.png";